module.exports = __webpack_public_path__ + "media/src/images/why-invoease-55cf3a854c1282be5985e0cd6ab24eb0.jpg";